import React from 'react';
import PropTypes from 'prop-types';
import { SHeading2 } from './style';

const Heading2 = ({
  text,
  isUnderlined,
  colour,
  display,
  padding,
  $extraStyle,
  className,
}) => {
  return (
    <SHeading2
      className={className}
      $extraStyle={$extraStyle}
      padding={padding}
      colour={colour}
      display={display}
      isUnderlined={isUnderlined}
      // text={`${text} `}
    >
      {text}
    </SHeading2>
  );
};

Heading2.propTypes = {
  isUnderlined: PropTypes.bool,
  text: PropTypes.string,
  colour: PropTypes.string,
  display: PropTypes.string,
  padding: PropTypes.string,
  $extraStyle: PropTypes.string,
  className: PropTypes.string,
};

export default Heading2;
